import {
    Button,
    CardMedia,
    Dialog,
    DialogActions,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    FormHelperText,
    Grid,
    useTheme
} from "@mui/material";
import React, { useEffect } from "react";
import InfoTooltip from "../../utils/UI/InfoTooltip";

const bookingIncrementsOptions = [5, 10, 15, 20, 30, 45, 60];

function BookingTab({
    bookingStates,
    bookingStatesChangeHandler,
    bookingFlowSettingsFiles,
    showTos,
    oldTosURL,
    openCloseTosHandler,
    mode,
    timeSuggestionsEnabled
}) {
    useEffect(() => {
        console.log("Old TOS URL useEffect", oldTosURL);
    }, [oldTosURL]);

    const theme = useTheme();
    const uniqueQuery = `?t=${Date.now()}`; // or use any other unique identifier
    const pdfUrlWithQuery = bookingStates.tosURL + uniqueQuery;

    const openNewTab = () => {
        window.open(
            "https://www.gomarketbox.com/help-articles/how-to-change-services-page",
            "_blank"
        );
    };
    return (
        <>
            <Dialog
                open={showTos}
                fullWidth
                maxWidth="lg"
                sx={{ mt: "36px", mb: "36px" }}
            >
                <CardMedia
                    component="iframe"
                    style={{ height: "100vh", scrolling: "no" }}
                    src={
                        mode === "Add" && bookingFlowSettingsFiles.tosFile
                            ? URL.createObjectURL(
                                  bookingFlowSettingsFiles.tosFile
                              )
                            : pdfUrlWithQuery
                    }
                    scrolling="no"
                ></CardMedia>
                <DialogActions>
                    <Button
                        onClick={(e) => {
                            openCloseTosHandler("close");
                        }}
                        color="primary"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <>
                <Grid item xs={12} sm={12}>
                    <FormControl sx={{ width: "50%", pr: "9px" }}>
                        <InputLabel>Service display behaviour</InputLabel>
                        <Select
                            id="services-display-field"
                            label="Service display behaviour"
                            variant="outlined"
                            disableUnderline
                            name={"servicesDisplay"}
                            value={bookingStates.servicesDisplay}
                            onChange={bookingStatesChangeHandler}
                            InputProps={{ shrink: false }}
                        >
                            <MenuItem key={"LIST"} value={"LIST"}>
                                List style (see example&nbsp;
                                <span
                                    style={{
                                        fontFamily: "Roboto",
                                        textDecoration: "underline"
                                    }}
                                    onClick={openNewTab}
                                >
                                    here
                                </span>
                                )
                            </MenuItem>

                            <MenuItem key={"CARD"} value={"CARD"}>
                                Card style (see example&nbsp;
                                <span
                                    style={{
                                        fontFamily: "Roboto",
                                        textDecoration: "underline"
                                    }}
                                    onClick={openNewTab}
                                >
                                    here
                                </span>
                                )
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <FormControl sx={{ width: "50%", pr: "9px" }}>
                        <InputLabel>
                            Service category display behaviour
                        </InputLabel>
                        <Select
                            id="category-display-field"
                            label="Service category display behaviour"
                            variant="outlined"
                            disableUnderline
                            name={"categoryDisplay"}
                            value={bookingStates.categoryDisplay}
                            InputProps={{ shrink: false }}
                            onChange={bookingStatesChangeHandler}
                        >
                            <MenuItem
                                key={"ALLOPEN"}
                                value={"ALLOPEN"}
                            >{`All categories open`}</MenuItem>

                            <MenuItem
                                key={"FIRSTOPEN"}
                                value={"FIRSTOPEN"}
                            >{`Only first category open`}</MenuItem>

                            <MenuItem
                                key={"ALLCLOSED"}
                                value={"ALLCLOSED"}
                                sx={{
                                    minHeight: "fit-content !important",
                                    textWrap: "auto",
                                    padding: "8px 18px",
                                    alignItems: "flex-start",
                                    flexDirection: "column"
                                }}
                            >
                                <Typography>All categories closed</Typography>
                                {bookingStates.categoryDisplay !==
                                    "ALLCLOSED" && (
                                    <Typography
                                        sx={{
                                            fontSize: "12px",
                                            color: theme.palette.grey.medium
                                        }}
                                    >
                                        Recommended for businesses with more
                                        than 20 services across multiple
                                        categories
                                    </Typography>
                                )}
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <FormControl sx={{ width: "50%", pr: "9px" }}>
                        <InputLabel>Service price display behaviour</InputLabel>
                        <Select
                            id="services-prices-field"
                            label="Service price display behaviour"
                            variant="outlined"
                            disableUnderline
                            name={"displayServicePrices"}
                            value={bookingStates.displayServicePrices}
                            onChange={bookingStatesChangeHandler}
                            InputProps={{ shrink: false }}
                        >
                            <MenuItem key={"show"} value={true}>
                                Show prices on step 1 of booking flow
                            </MenuItem>
                            <MenuItem key={"d-show"} value={false}>
                                Don’t show prices on step 1 of booking flow
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    sx={{ paddingTop: "0px !important" }}
                >
                    <Grid
                        container
                        item
                        spacing={2.25}
                        xs={12}
                        justifyContent="flex-start"
                    >
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <InputLabel>Booking increments</InputLabel>
                                <Select
                                    id="booking-increment-field"
                                    label="Booking increments"
                                    variant="outlined"
                                    disableUnderline
                                    name={"bookingIncrements"}
                                    value={bookingStates.bookingIncrements}
                                    onChange={bookingStatesChangeHandler}
                                >
                                    {bookingIncrementsOptions.map((minutes) => (
                                        <MenuItem
                                            key={minutes}
                                            value={+minutes}
                                        >{`${minutes} mins`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={3}
                            sx={{ paddingLeft: "9px !important" }}
                        >
                            <InfoTooltip
                                title={
                                    "Increment between possible appointment start times – not applicable if Smart Clusters optimization is enabled"
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} />
                        <Grid item xs={12} sm={3} />
                    </Grid>
                </Grid>
            </>
        </>
    );
}

export default BookingTab;
